export default __webpack_public_path__ + "static/media/helicopter.c93e64a0.png";